import { Outlet } from "react-router-dom";

const WfhRoot = () => {
  return <Outlet />;
};

export default WfhRoot;
